import ChevronDownIcon from '@assets/icons/chevron-down.svg';
import React, { useRef, useState } from 'react';
import { Button, Props as ButtonProps } from '@/components/button';
import { ItemSortOrder } from '@/contexts/item-context-types';
import { SortOrderActionSheet } from './sort-order-action-sheet';
import { SortOrders } from '@/contexts/user-context';
import { sortOrderTranslationMap } from './sort-order-select-list';
import { useTheme } from '@/contexts/theme-context';
import { View } from 'react-native';

export interface Props<T> {
  buttonProps?: Partial<ButtonProps>;
  onChange: (sortOrder: T) => void;
  supportedSortOptions: T[];
  value: T;
}

export const SortOrderButton = <T extends SortOrders = ItemSortOrder>({
  buttonProps = {},
  onChange,
  supportedSortOptions,
  value,
}: Props<T>) => {
  const theme = useTheme();

  const buttonRef = useRef<View>(null);
  const [showSortOrderActionSheet, setShowSortOrderActionSheet] =
    useState(false);

  return (
    <>
      <Button
        onPress={() => setShowSortOrderActionSheet(true)}
        ref={buttonRef}
        rightElement={<ChevronDownIcon fill={theme.colors.primary} />}
        size="small"
        testID="sort-order-button"
        trackingData={{ name: 'sort_order_button' }}
        type="tertiary"
        {...buttonProps}
      >
        {sortOrderTranslationMap[value]}
      </Button>
      <SortOrderActionSheet<T>
        buttonRef={buttonRef}
        isVisible={showSortOrderActionSheet}
        onChange={onChange}
        onClose={() => setShowSortOrderActionSheet(false)}
        supportedSortOptions={supportedSortOptions}
        value={value}
      />
    </>
  );
};
